// react
import React from 'react';

// third-party
import PropTypes from 'prop-types';

// application
import {
    ManuFactureSvg,
    LightBulbSvg,
    CalendarSvg,
    BuisinessPlan,
    QualityContol,
    MoneyBag
} from '../../svg';


export default function BlockFeatures(props) {
    const { layout } = props;

    return (
        <div className={`block block-features block-features--layout--${layout}`}>
            <div className="container">
                <div className="block-features__list">
                    <div className="block-features__item">
                        <div className="block-features__icon">
                            <BuisinessPlan />
                        </div>
                        <div className="block-features__content">
                            <div className="block-features__title">Скорость</div>
                            <div className="block-features__subtitle">Обрабатываем заявки и присылаем КП на инструмент в день обращения.</div>
                        </div>
                    </div>
                    <div className="block-features__divider" />
                    <div className="block-features__item">
                        <div className="block-features__icon">
                            <MoneyBag />
                        </div>
                        <div className="block-features__content">
                            <div className="block-features__title">Цены</div>
                            <div className="block-features__subtitle">Лучшие цены на рынке. На товар из наличия скидки до 40%</div>
                        </div>
                    </div>
                    <div className="block-features__divider" />
                    <div className="block-features__item">
                        <div className="block-features__icon">
                            <QualityContol />
                        </div>
                        <div className="block-features__content">
                            <div className="block-features__title">Сервис</div>
                            <div className="block-features__subtitle">Подробно консультируем клиентов и осуществляем подбор инструмента.</div>
                        </div>
                    </div>
               
                </div>
            </div>
        </div>
    );
}

BlockFeatures.propTypes = {
    layout: PropTypes.oneOf(['classic', 'boxed']),
};

BlockFeatures.defaultProps = {
    layout: 'classic',
};
